<template>
    <div class="page">
        <div class="back" @click="goBack">< 原产地验证</div>
        <div class="flex-czjz" v-if="dataInfo.originName">
            <div class="label">验证产地：</div>
            <div class="value">{{ dataInfo.originName }}</div>
        </div>
        <div class="flex-czjz" v-if="dataInfo.accuracy">
            <div class="label">准确率：</div>
            <div class="value">{{ dataInfo.accuracy }}%</div>
        </div>
        <div class="box" v-if="dataInfo.isotope || dataInfo.multiElements">
            <div class="label no-flex">特征指标：</div>
            <div class="value-card">
                <div class="flex-czjz" style="align-items: flex-start;" v-if="dataInfo.isotope">
                    <div class="label">稳定同位素</div>
                    <div class="value">{{ dataInfo.isotope }}</div>
                </div>
                <div class="flex-czjz" style="align-items: flex-start;" v-if="dataInfo.multiElements">
                    <div class="label">多元素</div>
                    <div class="value">{{ dataInfo.multiElements }}</div>
                </div>
            </div>
        </div>
        <div class="flex-czjz" v-if="dataInfo.verifyTime">
            <div class="label">验证时间：</div>
            <div class="value">
                {{ moment(dataInfo.verifyTime).format('YYYY年MM月DD日') }}
            </div>
        </div>
        <div v-if="dataInfo.othersRemark">
            <div class="label" style="margin-bottom: 2.4vw">其他说明:</div>
            <div class="value" style="width: 100%;white-space: pre-wrap;" v-html="dataInfo.othersRemark"></div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    data() {
        return {
            moment,
            dataInfo: {},
        }
    },
    created() {
        // const {list} = this.$route.query || {}
        // this.list = JSON.parse(list)
        this.dataInfo = JSON.parse(this.$route.query.info)
        console.log(this.dataInfo)
    },
    methods: {
        goBack() {
            this.$router.back()
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../styles/common.scss';
.page {
    text-align: left;
    background: url('https://h5-resource.obs.cn-east-2.myhuaweicloud.com/h5-share/origin-bg.png');
    background-size: contain;
    height: 100vh;
    padding: pxtovw(15) pxtovw(20);
    box-sizing: border-box;
    .back {
        margin-bottom: pxtovw(27);
        background-color: #00a680;
        display: inline-block;
        padding: pxtovw(4) pxtovw(18);
        border-radius: pxtovw(16);
        font-size: pxtovw(12);
        color: #fff;
        font-weight: bold;
    }
    .flex-czjz {
        display: flex;
        align-items: center;
        font-size: pxtovw(14);
        margin-bottom: pxtovw(16);
    }
    .label {
        width: pxtovw(70);
        color: #6f747a;
        flex: none;
        font-size: pxtovw(14);
    }
    .value {
        color: #333333;
        font-weight: 500;
        font-size: pxtovw(14);
    }
    .no-flex {
        margin-bottom: pxtovw(10);
    }
    .box {
        margin-bottom: pxtovw(16);
    }
    .value-card {
        width: 100%;
        padding: pxtovw(16) pxtovw(12) 1px;
        background: rgba(0, 166, 128, 0.08);
        border-radius: pxtovw(8);
        box-sizing: border-box;
        .label {
            font-size: pxtovw(13);
            margin-right: pxtovw(12);
        }
    }
}
</style>
